import styled from 'styled-components';
export const _Popover = styled.div `
    background: white;
    border: 1px solid silver;
    border-radius: 0.5rem;
    padding: 1rem;
    font-family: ${props => props.theme.fontBase};
    color: ${props => props.theme.primary.base};
    max-width: 400px;
`;
export const _PopoverContent = styled.div `
    display: flex;
    align-items: center;
    gap: 0.5rem;
`;
export const _PopoverIcon = styled.div `
    cursor: pointer;

    svg {
        display: block;
    }
`;
